import { render, staticRenderFns } from "./userIcon.vue?vue&type=template&id=390ee008&scoped=true&"
import script from "./userIcon.vue?vue&type=script&lang=ts&"
export * from "./userIcon.vue?vue&type=script&lang=ts&"
import style0 from "./userIcon.vue?vue&type=style&index=0&id=390ee008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ee008",
  null
  
)

component.options.__file = "userIcon.vue"
export default component.exports